import makeBreadcrumbs from "../../shared/containers/make_breadcrumbs";

import { crumbOverviewClick } from "../actions/focus_view";

const segmentDefinitions = [
  ["overview", crumbOverviewClick, true]
];

export default makeBreadcrumbs(segmentDefinitions);
